module.exports = __webpack_public_path__ + "img/icon-payment-nfc-blue@3x.ea165a03.png";